



































import { Component, Vue, Watch } from 'vue-property-decorator';
import { forbidSelect } from '@/global/utils';
import { validate, getLib, answerLib, getCheckLib } from '@/api/task/judge';
import JudgeRadio from '@/components/judge/judgeRadio.vue';
import JudgeCheckBox from '@/components/judge/judgeCheckbox.vue';
import JudgeTranslate from '@/components/judge/judgeTranslate.vue';
import NumberInfo from '@/components/numberInfo.vue';

@Component({
  components: {
    JudgeRadio,
    JudgeCheckBox,
    JudgeTranslate,
    NumberInfo,
  },
})
export default class JudgeLib extends Vue {
  // 当前题目
  private lib: any = {};
  // 转写答案
  private text = '';
  // 当前题目答案
  private answer = '';
  // 是否可以提交
  private submitClick = false;
  // 加载
  private loading: boolean = false;
  get task() {
    return this.$store.state.task;
  }
  private created() {
    // this.handlerNextPage();
    this.getCheckLib();
  }
  // 获取数据
  private async getCheckLib() {
    const id = this.$route.params.id;
    const res: any = await validate({ id: id });
    if (res.code == '200') {
      const resp: any = await getLib({ tid: id });
      (this.$refs.judgePage as any).resetAnswer('');
      this.lib = resp;
      this.submitClick = false;
      this.text = '';
      this.loading = false;
    }
  }
  private goDetail() {
    this.$router.push({
      name: 'detail',
      params: { page: 'judge', id: this.task.id },
    });
  }
  // 提交
  private async answerLib() {
    const res: any = await answerLib({ id: this.lib.id, answer: this.answer });
    if (res.code === '200') {
      (this.$refs.judgePage as any).resetAnswer('');
      this.submitClick = false;
      this.text = '';
      this.getCheckLib();
    } else {
      const msg = res.message;
      this.$Modal.confirm({
        title: msg,
        onOk: () => {
          this.goDetail();
        },
        onCancel: () => {
          this.goDetail();
        },
      });
    }
  }

  // 上一题
  private handlerPrevPage() {}
  // 下一题
  private handlerNextPage() {
    // 不同类型，点击提交时响应不同
    // 有预设答案 转写有答案
    if (this.lib.type == '204') {
      // 提交
      if (!this.submitClick) {
        const res = (this.$refs.judgePage as any).handleValidate();
        if (res) {
          let preAnswer = JSON.parse(this.lib.question).text;
          if (res.answer.replace(/(^\s*)|(\s*$)/g, '') !== preAnswer) {
            this.submitClick = true;
          } else {
            this.handlerCommonNext(res);
          }
        }
      } else {
        if (!this.text) {
          this.$Modal.info('请输入<我认真校对了>');
          return;
        } else {
          // 继续提交
          const res = (this.$refs.judgePage as any).handleValidate();
          if (res) {
            this.handlerCommonNext(res);
          }
        }
      }
    } else {
      const res = (this.$refs.judgePage as any).handleValidate();
      if (res) {
        this.handlerCommonNext(res);
      }
    }
  }
  private handlerCommonNext(res) {
    this.loading = true;
    if (this.lib.type == 2) {
      this.answer = res.answer.join(',');
    } else {
      this.answer = res.answer ? res.answer : res;
    }
    this.answerLib();
  }
}
